// import React, { Component } from "react";
import {PaymentRestService} from './restServices/restServices';
import VIDABOO_CONSTANTS from '../config/consts';
import storageService from './storageService';

// let privateState = {}; // private variables for this service.
// let alreadyInitiated = false; // used for singletonProcess
let service = {};
service.get = (
  sessionTemplateId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const PaymentInitRequest = {
    token: token ? token : storageService.getItem('token'),
    sessionTemplateId: sessionTemplateId,
    returnUrl:
      VIDABOO_CONSTANTS.PAYPAL_RETURN_URL + '/payments/c2c-payment.html?',
    // 'returnUrl': VIDABOO_CONSTANTS.PAYPAL_RETURN_URL + '/index.html/#/callInPopup',
    cancelUrl:
      VIDABOO_CONSTANTS.PAYPAL_RETURN_URL + '/payments/c2c-payment.html?',
  };
  PaymentRestService.save(
    {
      endpoint: 'pay',
    },
    PaymentInitRequest,

    (resource) => {
      // success
      console.debug(resource);
      if (successCallbackFunction) {
        // console.debug("payment init request success");
        successCallbackFunction(resource);
      }
    },
    (response) => {
      // failure
      console.debug(response.data);
      failCallbackFunction && failCallbackFunction(response.data);
    },
  );
};
service.getPaymentDetails = (
  paypalKey,
  moneyTransactionId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  // console.debug("service getPaymentDetails ", paypalKey);
  var requestObject = {
    paypalPaymentKey: paypalKey,
    moneyTransactionId: moneyTransactionId,
  };
  // console.debug(requestObject);
  PaymentRestService.save(
    {
      endpoint: 'details',
    },
    requestObject,

    (resource) => {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    (response) => {
      // failure
      console.debug(response.data);
      failCallbackFunction && failCallbackFunction(response.data);
    },
  );
};
service.verifyPaypalEmail = (
  email,
  currency,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const paymentVerificationRequest = {
    receiverEmail: email,
    currency,
    token: token ? token : storageService.getItem('token'),
  };
  PaymentRestService.save(
    {
      endpoint: 'verifyEmail',
    },
    paymentVerificationRequest,

    (resource) => {
      // success
      console.debug(resource);
      if (successCallbackFunction) {
        // console.debug("payment init request success");
        successCallbackFunction(resource);
      }
    },
    (response) => {
      // failure
      console.debug(response.data);
      failCallbackFunction && failCallbackFunction(response.data);
    },
  );
};

const paypalPaymentService = {...service};
export default paypalPaymentService;
